module.exports = __webpack_public_path__ + "static/media/slogan-cooperation.40d19540.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/slogan-cooperation.svg
// module id = 206
// module chunks = 6